export default "__VITE_ASSET__Csh$L71w__"